export type BillingPeriod = 'monthly' | 'quarterly' | 'lifetime'

/** Public prices. Stripe price IDs remain configured on the server. */
export const PRICING = {
  monthly: { amount: 7, currency: 'USD', interval: 'month', label: '/mo', savings: null },
  quarterly: { amount: 17, currency: 'USD', interval: 'quarter', label: '/qtr', savings: '19%' },
  lifetime: { amount: 99, currency: 'USD', interval: 'once', label: ' once', savings: null },
} as const

export const PRODUCT_DESCRIPTION = 'Save jobs, track applications, and manage interviews and follow-ups in one place with JobTrackr.it.'
